import React, { useState, useEffect } from 'react'
import html2canvas from 'html2canvas'
import moment from 'moment'
import * as R from 'ramda'
import { createUseStyles } from 'react-jss'

import { Row, Col, Button } from 'antd'

import config from '../config'

import cloud3Img from '../assets/images/img_cloud_3.png'
import tree1Img from '../assets/images/img_tree_1.png'
import tree2Img from '../assets/images/img_tree_2.png'

const imgBaseUrl = config.firebase.getImageUrl()

const bannerBgImg = `${imgBaseUrl}/Party%2Fimg_game_progress_banner_bg.png?alt=media`
const bannerSunImg = `${imgBaseUrl}/Party%2Fimg_game_progress_sun.png?alt=media`
const goalImg = `${imgBaseUrl}/Party%2Fimg_game_goal.png?alt=media`
const certificateBgImg = `${imgBaseUrl}/Party%2Fimg_certificate_bg.png?alt=media`
const paperBgImg = `${imgBaseUrl}/Party%2Fimg_certificate_paper_bg.png?alt=media`
const footerElementImg = `${imgBaseUrl}/Party%2Fimg_game_over_drop.png?alt=media`

const useStyles = createUseStyles({
    footerBG: props => ({
        width: "100%",
        position: "absolute",
        top: props.top,
        left: "0",
        overflow: "hidden",
        zIndex: "-1",
    }),
})

function CompleteFooterBg({ children, ...props }) {
    const classes = useStyles(props)
    return (
        <div className={classes.footerBG}>
            <img src={children} className="party-login-bg-img" alt="background" />
        </div>
    )
}

export default function PartyComplete(props) {
    const { partyInfo, userRecord, handleSyncProfile, synchronizing } = props

    const clientWidth = document.documentElement.clientWidth

    const [rank, setRank] = useState("—")

    useEffect(() => {
        let rankTemp = "—"
        const re = /0\/\d+/

        if (!R.isNil(userRecord.rank)) {
            if (!re.test(userRecord.rank)) {
                rankTemp = userRecord.rank
            }
        }
        setRank(rankTemp)

    }, [userRecord])

    const handleDownload = () => {
        html2canvas(
            document.querySelector("#certificate"), downloadOpt)
            .then(canvas => {
                let downloadFile = document.createElement('a')
                downloadFile.href = canvas.toDataURL()
                downloadFile.download = 'certificate.png'
                downloadFile.click()
            })
    }

    const downloadOpt = {
        width: 596,
        height: 843,
        windowWidth: 596 + 34,
        windowHeight: 843,
        scale: 3,
        backgroundColor: null,
    }

    return (
        <div>
            {/* Backgrond */}
            <div className="party-competition-upper-frame">
                <img src={bannerBgImg} className="party-login-bg-img" alt="background" />
            </div>
            <div className="party-competition-upper-frame">
                <img src={bannerSunImg} className="party-login-bg-img" alt="background" />
            </div>

            <img src={cloud3Img} className="party-competition-cloud3-img" alt="cloud" />

            <CompleteFooterBg top={375 >= clientWidth ? 215 + (375 - clientWidth) : 215 + (375 - clientWidth) * 0.39}>{certificateBgImg}</CompleteFooterBg>

            {/* Goal */}
            <Row type="flex" justify="center" className="party-complete-goal-frame">
                <div className="party-complete-goal-image-frame">
                    <img src={goalImg} className="party-login-bg-img" alt="goal" />
                </div>
                <Col span={24}>
                    <p className="party-complete-goal-title">完賽證明</p>
                </Col>
                <Col span={24}>
                    <p className="party-complete-goal-font">請盡快下載證明</p>
                </Col>
                <Col span={24}>
                    <p className="party-complete-goal-font">活動若下架，證明將無法提供下載</p>
                </Col>
            </Row>

            <Row type="flex" justify="center" style={{ marginTop: "26px" }}>
                <Button
                    className="party-complete-goal-sync-btn"
                    onClick={() => handleSyncProfile()}
                    loading={synchronizing}
                >
                    同步我的個人資料
                </Button>

                <Button
                    className="party-complete-goal-download-btn"
                    onClick={() => handleDownload()}
                    style={{ marginLeft: "10px" }}
                >
                    下載證明
                </Button>
            </Row>

            <div className="party-complete-goal-certificate-frame">
                <Row type="flex" justify="center" id="certificate" className="party-complete-goal-certificate-paper">
                    <img src={paperBgImg} className="party-complete-goal-certificate-paper-bg" alt="certificate" />

                    <div className="party-complete-goal-certificate-paper-title-frame">
                        <p className="party-complete-goal-certificate-paper-title">{partyInfo.title}</p>
                    </div>

                    <div className="party-complete-goal-certificate-paper-content-frame">
                        <Row type="flex" justify="space-between" align="middle">
                            <Col>
                                <p className="party-complete-goal-certificate-paper-content-title">姓名</p>
                                <p className="party-complete-goal-certificate-paper-content-eng">Name</p>
                            </Col>

                            <Col>
                                <p className="party-complete-goal-certificate-paper-content-font">{userRecord.name || "FitGames用戶"}</p>
                            </Col>
                        </Row>
                        <hr />

                        <Row type="flex" justify="space-between" align="middle">
                            <Col>
                                <p className="party-complete-goal-certificate-paper-content-title">項目</p>
                                <p className="party-complete-goal-certificate-paper-content-eng">Event</p>
                            </Col>

                            <Col>
                                <p className="party-complete-goal-certificate-paper-content-font">{"21K 馬拉松"}</p>
                            </Col>
                        </Row>
                        <hr />

                        <Row type="flex" justify="space-between" align="middle">
                            <Col>
                                <p className="party-complete-goal-certificate-paper-content-title">個人成績</p>
                                <p className="party-complete-goal-certificate-paper-content-eng">Net Time</p>
                            </Col>

                            <Col>
                                <p className="party-complete-goal-certificate-paper-content-font">
                                    {userRecord.duration ? moment.utc(userRecord.duration * 1000).format("HH:mm:ss") : "—"}
                                </p>
                            </Col>
                        </Row>
                        <hr />

                        <Row type="flex" justify="space-between" align="middle">
                            <Col>
                                <p className="party-complete-goal-certificate-paper-content-title">總名次</p>
                                <p className="party-complete-goal-certificate-paper-content-eng">Overall Ranking</p>
                            </Col>

                            <Col>
                                <p className="party-complete-goal-certificate-paper-content-font">{rank}</p>
                            </Col>
                        </Row>
                        <hr />

                        <p className="party-complete-goal-certificate-paper-content-footer-font">特此證明  以茲鼓勵</p>

                        <p className="party-complete-goal-certificate-paper-content-date">{moment().format("YYYY 年 MM 月 DD 日")}</p>
                    </div>
                </Row>
            </div>

            {/* Footer image */}
            <Row type="flex" justify="center" style={{ position: "relative" }}>
                <div className="party-complete-footer-frame">
                    <img src={footerElementImg} className="party-login-bg-img" alt="footer" />
                </div>

                <img src={tree1Img} className="party-complete-tree1-img" alt="tree" />
                <img src={tree2Img} className="party-complete-tree2-img" alt="tree" />

            </Row>

        </div>
    )
}